require.register("modules/bsc-conclusion/bsc-conclusion-activity/page-8/page-8", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page8 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page8;

  
});

